import { createReducer } from '@reduxjs/toolkit';
import { fetchClaimStripePaymentsThunk } from './claim-stripe-payments.thunk';
import { ClaimStripePaymentsByClaimState, ClaimStripePaymentsState } from './claim-stripe-payments.types';

const emptyStripePaymentTotal = {
  totalCharged: 0,
  totalCaptured: 0,
  hasManualRefundOrDisputeHandling: false,
  paymentCount: 0,
};

const emptyClaimState: ClaimStripePaymentsByClaimState = {
  payments: [],
  stripePaymentTotal: emptyStripePaymentTotal,
  stripePaymentTotalsByOrder: [],
  isLoading: false,
  hasFetched: false,
};

const initialState: ClaimStripePaymentsState = {
  byClaimId: {},
};

export default createReducer(initialState, (builder) => {
  builder
    .addCase(fetchClaimStripePaymentsThunk.pending, (state, action) => {
      const claimId = action.meta.arg.claimId;
      const currentState = state.byClaimId[claimId] || emptyClaimState;
      state.byClaimId[claimId] = {
        ...currentState,
        isLoading: true,
        error: undefined,
      };
    })
    .addCase(fetchClaimStripePaymentsThunk.fulfilled, (state, action) => {
      const claimId = action.meta.arg.claimId;
      state.byClaimId[claimId] = {
        payments: action.payload.stripePayments,
        stripePaymentTotal: action.payload.stripePaymentTotal,
        stripePaymentTotalsByOrder: action.payload.stripePaymentTotalsByOrder,
        isLoading: false,
        hasFetched: true,
        error: undefined,
      };
    })
    .addCase(fetchClaimStripePaymentsThunk.rejected, (state, action) => {
      const claimId = action.meta.arg.claimId;
      const currentState = state.byClaimId[claimId] || emptyClaimState;
      state.byClaimId[claimId] = {
        ...currentState,
        isLoading: false,
        hasFetched: true,
        error: action.payload || action.error.message || 'Something went wrong.',
      };
    });
});
